import Vue from 'vue'
import mixins from '@/mixins'
Vue.mixin(mixins)
